import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
    selector: 'sl-no-permission',
    templateUrl: './no-permission.component.html',
    styleUrls: ['./no-permission.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class NoPermissionComponent {}
